var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUrl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "url") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_url",
    transform: "translate(4.602 3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3860",
    "data-name": "Rectangle 3860",
    width: 24,
    height: 24,
    transform: "translate(-4.602 -3)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "link_FILL0_wght400_GRAD0_opsz48",
    d: "M84-672a3.855,3.855,0,0,1-2.83-1.17A3.855,3.855,0,0,1,80-676a3.855,3.855,0,0,1,1.17-2.83A3.855,3.855,0,0,1,84-680h2.8a.579.579,0,0,1,.427.173.586.586,0,0,1,.173.43.574.574,0,0,1-.173.427.585.585,0,0,1-.427.17H84a2.7,2.7,0,0,0-1.983.815A2.693,2.693,0,0,0,81.2-676a2.709,2.709,0,0,0,.817,1.985A2.7,2.7,0,0,0,84-673.2h2.8a.579.579,0,0,1,.427.173.586.586,0,0,1,.173.43.574.574,0,0,1-.173.426.585.585,0,0,1-.427.17Zm1.5-3.4a.579.579,0,0,1-.427-.174A.586.586,0,0,1,84.9-676a.574.574,0,0,1,.173-.427.585.585,0,0,1,.427-.17h5a.579.579,0,0,1,.428.174.586.586,0,0,1,.172.43.574.574,0,0,1-.172.427.585.585,0,0,1-.428.17Zm3.7,3.4a.579.579,0,0,1-.428-.174.586.586,0,0,1-.173-.43.574.574,0,0,1,.173-.427.585.585,0,0,1,.428-.17H92a2.7,2.7,0,0,0,1.983-.815A2.693,2.693,0,0,0,94.8-676a2.709,2.709,0,0,0-.817-1.985A2.7,2.7,0,0,0,92-678.8H89.2a.579.579,0,0,1-.428-.173.586.586,0,0,1-.173-.43.574.574,0,0,1,.173-.427A.585.585,0,0,1,89.2-680H92a3.855,3.855,0,0,1,2.83,1.17A3.855,3.855,0,0,1,96-676a3.855,3.855,0,0,1-1.17,2.83A3.855,3.855,0,0,1,92-672Z",
    transform: "translate(-80.602 685)",
    fill: "#08232f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrl);
export default __webpack_public_path__ + "static/media/url.27fd0c68c9df4aae868e15166fb9f3da.svg";
export { ForwardRef as ReactComponent };